export const levelLabels = ['New Offer Type', 'New Section', 'New Sub Section', 'New Field'];
